export default __webpack_public_path__ + "static/404_bucky_bg-7670a477cdc693ad8224d91c8ddc42c3.jpg";